module.exports = __webpack_public_path__ + "f65f35c23926605972710dd521715f19.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Zhihu.svg
// module id = Ind5
// module chunks = 3